export enum GenericComponentTestIds {
  BREADCRUMB_CONTAINER = 'breadcrumb-container',
  BREADCRUMB_ITEM = 'breadcrumb-item',
  BREADCRUMB_BACK_BUTTON = 'breadcrumb-back-button',
  TAB_ITEM_PREFIX = 'tab-item-',
}

export enum AppWrapTestIds {
  APP_WRAP_BRAND_NAME = 'app-wrap-brand-name',
}
